var React = require('react');

function ArrowAlt (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.3482 12.5197L2.82843 0L0 2.82843L12.5197 15.3482L0.353667 27.5142L3.18209 30.3426L18.1821 15.3426L15.3537 12.5142L15.3482 12.5197Z","fill":"currentColor"}));
}

ArrowAlt.defaultProps = {"width":"19","height":"31","viewBox":"0 0 19 31","fill":"none"};

module.exports = ArrowAlt;

ArrowAlt.default = ArrowAlt;
